import {useState} from "react";
import axiosInstance from "../API/Axios/AxiosConfig";
import URLS from "../API/Axios/URLS";
import {COMMUNITY_COMMENT_ACTIONS} from "../redux/Reducers/CommunityComments";
import {toast} from "react-toastify";


export default function useCommentSection(id) {
    const [state, setState] = useState({
        comments: [],
        count: 0,
        next: null,
        previous: null,
        pageNumber: 1,
        sortBy: "newest",
        isFirstLoad: true,
    });
    const [isLoading, setIsLoading] = useState(false);

    function getCommunityComments(pageNumber = 1, sortBy = "newest") {
        if (isLoading) return;

        setIsLoading(true)
        axiosInstance.get(URLS.getComments, {
            params: {
                page: pageNumber,
                sortBy: sortBy,
                questionId: id,
            }
        }).then((res) => {
            setState({
                count: res.data.count,
                comments: pageNumber === 1 ? [...res.data.results] : [...state.comments, ...res.data.results],
                next: res.data.next,
                previous: res.data.previous,
                pageNumber: pageNumber,
            })
        }).catch((err) => {
            if (err.response?.status === 404) {
                setState((pre => {
                    return {
                        ...pre,
                        next: null,
                        previous: null,
                    }
                }))
            }
        }).finally(() => {
            setIsLoading(false)
        })
    }


    function addNewComment(comment) {
        toast.promise(axiosInstance.post(URLS.addComment, {
                ...comment,
                questionId: id,
            }).then((res) => {
                setState(pre => {
                    return {
                        ...pre,
                        comments: [res.data?.data, ...pre.comments]
                    }
                })
            }),
            {
                pending: "Posting comment...",
                success: "Comment posted successfully.",
                error: "Comment failed to post.",
            }, {
                hideProgressBar: false,
            });
    }

    function loadMoreComments() {
        if (isLoading || !state?.next) return;
        getCommunityComments(state.pageNumber + 1, state.sortBy)
    }

    function SortBy(sortBy) {
        setState(pre => {
            return {
                ...pre,
                comments: [],
                sortBy: sortBy,
            }
        })
        getCommunityComments(1, sortBy)
    }

    const initalLoad = () => {
        if (!state.isFirstLoad) return;
        getCommunityComments()
        setState(pre => {
            return {
                ...pre,
                isFirstLoad: false,
            }
        })

    }

    function removeComment(id) {
        let cahcedComments = [...state.comments];
        let index = cahcedComments.findIndex((comment) => comment.id === id);
        if (index !== -1) {
            cahcedComments.splice(index, 1);
            setState(pre => {
                return {
                    ...pre,
                    comments: cahcedComments,
                    count: state.count - 1,
                }
            })
        }
    }

    function deleteComment(id) {
        toast.promise(axiosInstance.delete(URLS.DeleteAComment, {
            data: {
                commentId: id,
            }
        }).then((res) => {
            removeComment(id);
        }), {
            pending: "Deleting comment...",
            success: "Comment deleted successfully.",
            error: "Comment failed to delete.",
        }, {
            hideProgressBar: false,
        })
    }

    const actions = {
        getCommunityComments: getCommunityComments,
        loadMoreComments: loadMoreComments,
        SortBy: SortBy,
        addNewComment: addNewComment,
        initalLoad: initalLoad,
        reset: () => {
            setState({
                comments: [],
                count: 0,
                next: null,
                previous: null,
                pageNumber: 1,
                sortBy: "newest",
                isFirstLoad: true,
            })
        },
        deleteComment: deleteComment,
    }
    return [state, isLoading, actions]
}